// extracted by mini-css-extract-plugin
module.exports = {"node":"Node_node__3eJ6f"};